module.exports = __webpack_public_path__ + "static/media/VectorMap.b3241f2f.svg";